import ActionCable from 'actioncable'
import { Honeybadger } from '@honeybadger-io/react'
import Eventer from './eventer'
import { isEmpty } from 'lodash'
// import LogRocket from 'logrocket'
// import setupLogRocketReact from 'logrocket-react'
// import isEmpty from 'lodash/isEmpty'

const NODE_ENV = process.env.NODE_ENV
const PROJECT_ROOT = 'webpack:///./'
const DEBUGGABLE_ENVS = ['test', 'development', 'staging']

class SignWell {
  constructor (initializer = {}) {
    const {
      accessToken,
      amplitudeApiKey,
      browserInfo = 'unknown',
      flashMessages = '{}',
      honeybadgerJsApiKey,
      // logrocketToken,
      metaProfile = '{}',
      serverEvents = '[]'
    } = initializer
    this.accessToken = accessToken
    this.browserInfo = browserInfo
    this.flashMessages = JSON.parse(flashMessages)
    this.event = new Eventer({
      amplitudeApiKey,
      serverEvents: JSON.parse(serverEvents),
      metaProfile: JSON.parse(metaProfile)
    })

    const user = JSON.parse(metaProfile)

    const honeybadger = Honeybadger.configure({
      revision: GIT_REVISION,
      projectRoot: PROJECT_ROOT, // improves error grouping and linking to source code
      apiKey: honeybadgerJsApiKey,
      environment: NODE_ENV,
      debug: DEBUGGABLE_ENVS.includes(NODE_ENV)
    })

    if (!isEmpty(user)) {
      const { userName, email: userEmail, id: userId } = user
      honeybadger.setContext({ userName, userEmail, userId })
    }

    // LogRocket.init(logrocketToken, {
    //   release: GIT_REVISION,
    //   // hide SDK log on production
    //   shouldDebugLog: DEBUGGABLE_ENVS.includes(NODE_ENV),
    //   // dom recording settings
    //   dom: {
    //     isEnabled: true, // enable/disable recording, default to true
    //     textSanitizer: true, // hide all text, default to false
    //     inputSanitizer: true // hide all inputs, default to false
    //   }
    //   // network sanitizer, see the logrocket network privacy settings if needed
    //   // there are also URL and RESPONSE sanitizers
    //   // network: {
    //   //   requestSanitizer: request => {
    //   //     return request
    //   //   }
    //   // }
    // })
    //
    // // Setup react with logrocket
    // setupLogRocketReact(LogRocket)


    // Set up user identification
    // if (!isEmpty(user)) {
    //   const { userName, email, id } = user
    //   LogRocket.identify(id, {
    //     name: userName,
    //     email: email
    //   })
    // }

    // Logrocket/Honeybadger integration
    // LogRocket.getSessionURL(sessionURL => {
    //   Honeybadger.beforeNotify(notice => {
    //     if (notice && notice.context) notice.context.sessionURL = sessionURL
    //   })
    // })

    this.honeybadger = honeybadger
  }

  get hasNoConsumer () { return isEmpty(this.consumer) }

  get hasConsumer () { return !this.hasNoConsumer }

  get consumerIsNotActive () { return this.hasConsumer && !this.consumer.connection.isActive() }

  get hasSubscriptions () { return !isEmpty(this.consumerSubscriptions) }

  get hasNoSubscriptions () { return !this.hasSubscriptions }

  // Yes, the subscriptions collection is accessed via subscriptions.subscriptions ¯\_(ツ)_/¯
  get consumerSubscriptions () { return this.hasConsumer ? this.consumer.subscriptions.subscriptions : [] }

  createConsumer () {
    // Create consumer if none
    if (this.hasNoConsumer) {
      this.consumer = ActionCable.createConsumer(`${RELATIVE_URL_ROOT}websockets?access=${this.accessToken}`)
    }
    // reopen consumer if not active
    if (this.consumerIsNotActive) this.consumer.connection.open()
  }

  subscribeToChannel (options, callbacks = {}) {
    this.createConsumer()
    const subscription = this.consumer.subscriptions.create(options, callbacks)
    return subscription.identifier
  }

  unsubscribeFromChannel (identifier) {
    if (this.hasConsumer) {
      const subscription = this.consumerSubscriptions.find(sub => sub.identifier === identifier)
      if (subscription) subscription.unsubscribe()
      this.disconnectConsumer()
    }
  }

  disconnectConsumer () { this.hasNoSubscriptions && this.consumer.disconnect() }
}

const meta = document.querySelector("meta[name='signwell-initializer']")
const initializer = (meta && meta.dataset) || {}
const s$ = new SignWell(initializer)

switch (NODE_ENV) {
  case 'production':
    Object.keys(initializer).forEach(prop => delete initializer[prop])
    break
  case 'development':
  case 'staging':
    window.s$ = s$
    break
  case 'test':
    global.s$ = s$
}

export default s$
